module.exports = __webpack_public_path__ + "img/goods6_3.ca754a44.jpg";